import ReactDOM from 'react-dom';

export default class Alert {
    constructor(type, content, config) {
        this.type = type;
        this.config = config;

        this.handleCloseClick = this.handleCloseClick.bind(this);

        if (this.config.duration === 0) {
            if (!this.config.noClose) {
                this.config.manualClose = true;
            }
        } else {
            setTimeout(() => {
                this.hide();
            }, this.config.duration);
        }

        this.element = this.createElement(content);
        this.visible = false;
        this.setContent(content);
        this.progress = 'progress' in config ? config.progress : 1;
        this.hidingTimeout = null

        if (!config.hidden) {
            this.show();
        }
    }

    handleCloseClick() {
        this.hide();
    }

    createElement(content) {
        const element = document.createElement('div');
        const elementProgress = document.createElement('span');
        const elementContent = document.createElement('div');
        const elementClose = document.createElement('span');
        const elementCloseIcon = document.createElement('i');

        element.className = `alert-item alert-item-type-${this.type} ${(this.config.manualClose ? 'manual-close' : '')}`;
        elementProgress.className = 'alert-item-progress';
        elementContent.className = 'alert-item-content';
        elementClose.className = 'alert-item-close btn btn-small btn-simple-close';
        elementCloseIcon.className = 'ion ion-close-round';

        elementClose.addEventListener('click', this.handleCloseClick);

        elementClose.appendChild(elementCloseIcon);
        element.appendChild(elementProgress);
        element.appendChild(elementContent);
        element.appendChild(elementClose);

        return element;
    }

    getContainer() {
        return this.config.hard ? document.querySelector('.app-hard-alerts') : document.querySelector('.app-alerts')
    }

    show() {
        if (!this.getContainer()) {
            return;
        }

        this.getContainer().appendChild(this.element);

        this.element.classList.remove('animate-out');

        this.visible = true;

        if (this.hidingTimeout) {
            clearTimeout(this.hidingTimeout);
            this.hidingTimeout = null;
        }

        setTimeout(() => {
            this.element.classList.add('animate-in');

            this.config.onShow && this.config.onShow();
        }, 50);
    }

    hide(delay = 0, dontRemove, immidiate) {
        this.visible = false;

        const remove = () => {
            if (this.element.parentNode) {
                this.element.parentNode.removeChild(this.element);
            }

            this.config.onHide && this.config.onHide(dontRemove);
        }

        if (this.hidingTimeout) {
            clearTimeout(this.hidingTimeout);
            this.hidingTimeout = null;
        }

        if (immidiate) {
            remove();
            return;
        }

        return new Promise(res => {
            this.hidingTimeout = setTimeout(() => {
                this.hidingTimeout = null;
                this.element.classList.add('animate-out');

                setTimeout(() => {
                    remove();
                    res();
                }, 300);
            }, delay);
        });
    }

    setProgress(progress) {
        if (progress === this.progress) {
            return this;
        }

        if (progress > 0 && progress < 1) {
            this.element.classList.add('loading');
        } else if (progress === 1) {
            this.element.classList.remove('loading');
        }

        this.element.querySelector('.alert-item-progress').style.width = `${progress * 100}%`;
        this.progress = progress;

        return this;
    }

    setType(type) {
        if (type === this.type) {
            return this;
        }

        this.element.classList.remove(`alert-item-type-${this.type}`);
        this.element.classList.add(`alert-item-type-${type}`);
        this.type = type;

        return this;
    }

    setContent(content) {
        const elementContent = this.element.querySelector('.alert-item-content');

        try {
            if (typeof content === 'object') {
                ReactDOM.render(content, elementContent);
            } else {
                elementContent.innerHTML = content;
            }
        } catch (error) {
            console.error(error);
        }

        return this;
    }
}
